import { setURL } from '@/api/apiUtil'

export default {
  // 根據社區編號取得繳費通知列表
  getPaymentNoticeList: {
    url: (communityId) =>
      setURL('/paymentNotice/community/:communityId', { communityId }),
    method: 'get'
  },
  // 根據繳費通知編號取得住戶推播通知列表
  getPaymentNotice: {
    url: (paymentNoticeId) =>
      setURL('/paymentNotice/:paymentNoticeId', { paymentNoticeId }),
    method: 'get'
  },
  // 繳費通知推播
  sendPaymentNotice: {
    url: setURL('/paymentNotice'),
    method: 'post'
  }
}
